import { Component, Input, OnInit } from "@angular/core";
import { Link } from "../links.interface";
import { ChangeLinkAction, RemoveLinkAction } from "../links.actions";
import { Store } from "@ngrx/store";
import { ConfirmationDialogComponent } from "../../../shared/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { StartCheckingForInstallationInProgressAction } from "../../../signature-installation-state/signature-installation-state.actions";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../../shared/error-state-matcher";

@Component({
  selector: "app-link",
  templateUrl: "./link.component.html",
  styleUrls: ["./link.component.scss"],
  standalone: false,
})
export class LinkComponent implements OnInit {
  @Input() link: Link;
  form: UntypedFormGroup;
  editMode = false;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private store: Store,
    private dialog: MatDialog,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.fillInitialForm();
  }

  fillInitialForm = () => {
    this.form = new UntypedFormGroup({
      addonId: new UntypedFormControl(this.link.addonId, (c) =>
        Validators.required(c),
      ),
      name: new UntypedFormControl(this.link.name, (c) =>
        Validators.required(c),
      ),
      url: new UntypedFormControl(this.link.url, (c) => Validators.required(c)),
      text: new UntypedFormControl(this.link.text, (c) =>
        Validators.required(c),
      ),
    });
  };

  changeLink = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid) {
      return;
    }
    this.store.dispatch(new StartCheckingForInstallationInProgressAction());
    this.store.dispatch(
      new ChangeLinkAction(
        this.form.value as {
          addonId: string;
          name: string;
          url: string;
          text: string;
        },
      ),
    );
    this.changeEditMode();
  };

  cancelEditLink = () => {
    this.fillInitialForm();
    this.changeEditMode();
  };

  changeEditMode = () => {
    this.editMode = !this.editMode;
  };

  removeLink = (addonLinkId: string) => {
    this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: this.translate.instant(
            "addons.links.deleteConfirmationText",
          ) as string,
        },
      })
      .afterClosed()
      .subscribe((confirm) => {
        if (confirm) {
          this.store.dispatch(new RemoveLinkAction(addonLinkId));
        }
      });
  };
}
